import { render, staticRenderFns } from "./BackBtn.vue?vue&type=template&id=7c7ee7f8&"
import script from "./BackBtn.vue?vue&type=script&lang=js&"
export * from "./BackBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports